<template>
  <Modal width="902px" height="765px" borderRadius="0" @close="$emit('close')">
    <div class="modal__head" style="margin-bottom: 32px">
      <h3 class="modal__title">{{ modalTitle }} Статусы</h3>
      <div class="close" @click.stop="$emit('close')">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2" />
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2" />
        </svg>
      </div>
    </div>

    <section class="modal__content">
      <AppTabsSlider
        :space-between="60"
        :tabs="modalTabs"
        :isLinks="false"
        @switch="setActiveTab"
        :prop-active-tab-index="activeTabIndex + 1"
        style="margin-bottom:31px"
      />

      <div v-if="activeTabIndex === 0" class="statuses">
        <div class="statuses__col" style="width: 100%"> 
          <AppInput 
            title="Название"
            :value="status.name"
            :valid="validation.name"
            required
            @value-changed="setName"
            @got-focus="clearValidation('name')"
            width="250px"
          />
          <AppSwitch 
            title="В данном статусе заявка считается закрытой"
            @toggleCheck="setToggleClose"
            :onCheck="status.is_close"
            style="width:100%"
          />
          <AppSwitch 
            title="Статус на котором происходит формирование договора"
            @toggleCheck="setToggleShaping"
            :onCheck="status.is_shaping"
            style="width:100%"
          />
          <AppSwitch 
            title="Статус на котором происходит расчет стоимости"
            @toggleCheck="setToggleCalculate"
            :onCheck="status.is_calculate"
            style="width:100%"
          />
          <AppSwitch 
            title="Сквозной статус"
            @toggleCheck="setToggleThrough"
            :onCheck="status.is_through"
            style="width:100%"
          />
          <AppSwitch 
            title="Возможность отката"
            @toggleCheck="setToggleRollback"
            :onCheck="status.is_rollback"
            style="width:100%"
          />
          <AppSwitch 
            title="Возможность переключить из любого состояния заказа"
            @toggleCheck="setToggleManual"
            :onCheck="status.is_manual"
            style="width:100%"
          />
        </div>
        <div class="statuses__col">
          <AppColorPicker
            title="Цвет:"
            :value="status.color"
            @value-changed="setColor"
            withDefaultsColors
            width="100%"
          />
          <AppSelect
            title="Шаблон для отправки рабочему"
            :options="[]"
            :value="null"
            @value-changed="() => {}"
            placeholder="Не выбрано"
            name="template1"
          />
          <AppSelect
            title="Шаблон для отправки клиенту"
            :options="[]"
            :value="null"
            @value-changed="() => {}"
            placeholder="Не выбрано"
            name="template2"
          />
        </div>
      </div>

      <div v-if="activeTabIndex === 1" class="checkboxes">
        <div class="page__item" :key="item.field" v-for="item in status.fieldsList">
          <AppCheckbox
            :checked="status.fields.some(e => e == item.field)"
            :title="item.title"
            :value="item.access"
            @toggle-check="changeCheck(item.field)"
          />
        </div>
      </div>

      <div v-if="activeTabIndex === 2" class="notification">
        <AppSelect
          title="Роль для уведомлений о простое"
          :options="[]"
          :value="null"
          @value-changed="() => {}"
          placeholder="Не выбрано"
          name="role"
        />
        <AppInput 
          title="Количество дней простоя для уведомления"
          value="0"
        />
      </div>

      <div class="buttons">
        <AppButton 
          type="main" 
          title="Создать" 
          @click.stop.native="saveStatusInfo"
        />
        <AppButton 
          type="alt" 
          title="Отмена" 
          @click.native="$emit('close')" 
        />
      </div>
    </section>
  </Modal>
</template>

<script>
import Modal from './base/Modal.vue'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider.vue'
import AppButton from '@/components/page/button/AppButton.vue'
import AppCheckbox from '@/components/page/input/AppCheckbox.vue'
import AppSelect from '@/components/page/input/AppSelect.vue'
import AppInput from '@/components/page/input/AppInput'
import AppColorPicker from '@/components/page/input/AppColorPicker.vue'
import AppSwitch from '@/components/page/input/AppSwitch.vue'

export default {
  components: {
    Modal,
    AppTabsSlider,
    AppButton,
    AppCheckbox,
    AppSelect,
    AppInput,
    AppColorPicker,
    AppSwitch
  },
  props: {
    modalType: {
      type: String,
      default: 'create'
    },
    role: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      modalTabs: [
        { name: 'Статус', id: 0 },
        { name: 'Доступные поля', id: 1 },
        { name: 'Уведомление о простое', id: 2 }
      ],
      activeTabIndex: 0,
      statuses: [
        {
          text: 'Статус на котором происходит расчет стоимости'
        },
        {
          text: 'Сквозной статус'
        },
        {
          text: 'Возможность отката'
        },
        {
          text: 'Возможность переключить из любого состояния заказа'
        },
        {
          text: 'В данном статусе заявка считается закрытой'
        },
        {
          text: 'Статус на котором происходит формирование договора'
        }
      ],
      selectedСolor: null,
      currentRole: {
        id: this.role.id,
        name: this.role.name
      }
    }
  },
  computed: {
    status () {
      return this.$store.getters['[pvh] getStatusForUpdate']
    },
    modalTitle () {
      switch (this.modalType) {
        case 'create':
          return 'Создание'
        case 'update':
          return 'Обновление'
        default:
          return ''
      }
    },
    validation () {
      return this.$store.getters['[pvh] getStatusUpdateValidation']
    },
    activeTab () {
      return this.modalTabs[this.activeTabIndex]
    }
  },
  methods: {
    setActiveTab (tab, index) {
      this.activeTabIndex = index
    },
    setName (value) {
      this.$store.dispatch('[pvh] setStatusName', value)
    },
    setColor (value) {
      this.$store.dispatch('[pvh] setStatusColor', value)
    },
    setToggleManual () {
      this.$store.dispatch('[pvh] setStatusManual')
    },
    setToggleClose () {
      this.$store.dispatch('[pvh] setStatusClose')
    },
    setToggleShaping () {
      this.$store.dispatch('[pvh] setStatusShaping')
    },
    setToggleThrough () {
      this.$store.dispatch('[pvh] setStatusThrough')
    },
    setToggleRollback () {
      this.$store.dispatch('[pvh] setStatusRollback')
    },
    setToggleCalculate () {
      this.$store.dispatch('[pvh] setStatusCalculate')
    },
    changeCheck (field) {
      this.$store.commit('[pvh] CHANGE_STATUS_UPDATE_FIELD_CHECK', field)
    },
    clearValidation (inputName) {
      this.$store.dispatch('[pvh] statusUpdateClearValidation', inputName)
    },
    saveStatusInfo () {
      this.$store.commit('[pvh] ADD_STATUS_UPDATE_ROLE', this.currentRole)
      this.$store.dispatch('[pvh] statusUpdateSaveInfo', 'create')
    }
  }
}
</script>

<style scoped lang="scss">
.modal__content {
  display: flex;
  flex-direction: column;
  padding: 0 38px 57px;
  height: 100%;

  .statuses {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;

    .statuses__col {
      display: flex;
      flex-direction: column;
      row-gap: 27px;
    }
  }

  .checkboxes {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 30px;
  }

  .notification {
    display: grid;
    row-gap: 20px;
    width: 50%;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    width: 100%;
    height: 40px;
    margin-top: auto;
  }
}
</style>
